import { NavItemModel } from '../../common';

export const loginDebuggerNavItem: NavItemModel = {
  name: 'Login-Debugger',
  url: '/login-debugger',
  label: 'Login Debugger',
  icon: {
    name: 'ban-bug',
    family: 'light',
  },
};

export const liveUpdateDebuggerNavItem: NavItemModel = {
  name: 'Live-Update-Debugger',
  url: '/live-update-debugger',
  label: 'Live-Update-Debugger',
  icon: {
    name: 'rotate',
    family: 'light',
  },
};

export const featureFlagDebugger: NavItemModel = {
  name: 'Feature-Flag-Debugger',
  url: '/feature-flag-debugger',
  label: 'Feature Flag Debugger',
  icon: {
    name: 'flag',
    family: 'light',
  },
};

export const trackingDebugger: NavItemModel = {
  name: 'Tracking-Debugger',
  url: '/tracking-debugger',
  label: 'Tracking Debugger',
  icon: {
    name: 'chart-mixed',
    family: 'light',
  },
};

export const devNavigation: NavItemModel[] = [
  loginDebuggerNavItem,
  liveUpdateDebuggerNavItem,
  featureFlagDebugger,
  trackingDebugger,
];
